import type { CSSProperties } from 'react';

import type { MapVenue } from '../../../../api/regions';

interface Props {
  venues: MapVenue[];
  selectedId: string | null;
  onSelect: (id: string) => void;
  colorOf: (regionId: string | null) => string;
}

const EXCEPTION_BADGE: Record<string, { label: string; color: string } | null> = {
  auto: null,
  pin: { label: 'PINNED', color: '#0e874b' },
  exclude: { label: 'EXCLUDED', color: '#dc2626' },
};

const rowStyle = (on: boolean): CSSProperties => ({
  display: 'flex',
  alignItems: 'center',
  gap: 9,
  width: '100%',
  textAlign: 'left',
  padding: '8px 9px',
  borderRadius: 8,
  cursor: 'pointer',
  border: 'none',
  background: on ? 'var(--nb-primary-soft)' : 'transparent',
  font: 'inherit',
});

/** Venue roster with region dot + per-venue exception badge. */
export function VenueList({ venues, selectedId, onSelect, colorOf }: Props) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      {venues.map((v) => {
        const badge = EXCEPTION_BADGE[v.exception];
        return (
          <button key={v.id} onClick={() => onSelect(v.id)} style={rowStyle(selectedId === v.id)}>
            <span
              style={{
                width: 9,
                height: 9,
                borderRadius: 999,
                background: colorOf(v.regionId),
                flexShrink: 0,
              }}
            />
            <span
              style={{
                flex: 1,
                minWidth: 0,
                fontSize: 12.5,
                color: 'var(--nb-ink)',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              {v.name}
            </span>
            {badge && (
              <span style={{ fontSize: 9, fontWeight: 700, color: badge.color }}>
                {badge.label}
              </span>
            )}
            <span style={{ fontSize: 10.5, color: 'var(--nb-subtle)', flexShrink: 0 }}>
              {v.regionName ?? '—'}
            </span>
          </button>
        );
      })}
    </div>
  );
}
